const Header = () => {
    return (
        <div className="w-full mx-auto px-12 py-20 text-white text-sm">
            <div className="flex flex-cols items-end">
                <div className="flex-none w-9/12">
                    <div className="flex flex-row items-center space-x-2">
                        <span className="bg-white inline-block h-1 w-1 rounded-full"></span>
                        <span className="block mt-4 lg:inline-block lg:mt-0 text-white mr-4 uppercase font-sans text-xs">Projects</span>
                    </div>
                    <h1 className="py-4 text-5xl">
                        Our <span className="text-orange-500">Projects</span>
                    </h1>
                    <p className="text-sm">Digital experience matters. Here are some of our projects.</p>
                </div>
            </div>
        </div>
    )
}

export default Header